import { useState } from 'react';

interface WindCardProps {
  title: string;
  data?: Record<string, any>[];
  labelKey: string;
  valueKey: string;
  className?: string;
}

const Card: React.FC<WindCardProps> = ({
  title,
  data,
  labelKey,
  valueKey,
  className,
}) => {
  const [isFlightCancelled] = useState('No Information');

  const showBadgeTitles = ['Landing Site', 'Launch Site'].includes(title);


  const isLocationMissing =
    showBadgeTitles &&
    data?.find((item) => item[labelKey] === 'Location')?.[valueKey] === '--';

  return (
    <div className="p-4 bg-background">
      <div className="flex justify-between gap-2">
        <h2 className="text-lg font-semibold text-textColor text-left">
          {title}
        </h2>

        {isLocationMissing && (
          <span className={`w-[130px] h-[30px] px-3 py-1 rounded-full text-sm text-center font-medium bg-backgroundColor-noInformationTagBg text-backgroundColor-noInformationTagText`}>
            {isFlightCancelled}
          </span>
        )}
      </div>

      <div className={`grid ${className} mt-2 text-center`}>
        {data?.map((item, index) => (
          <div key={index} className="text-left">
            <p className="text-sm font-medium text-textColorGray">
              {item[labelKey]}
            </p>
            <p className="text-md text-textColorGray">{item[valueKey]}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Card;
